import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Login {
  private readonly http = inject(HttpClient);

  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(`${environment.apiPrefix}${environment.auth.login}`, {
      email,
      password
    });
  }
}
